import { render, staticRenderFns } from "./ProductSubNav.vue?vue&type=template&id=507f9b7f&"
import script from "./ProductSubNav.vue?vue&type=script&lang=js&"
export * from "./ProductSubNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports